export const ANNOTATION_LOOPED = 'BRUSH';
export const ANNOTATION_FREEHAND = 'PENCIL';
export const ANNOTATION_RECTANGLE = 'SQUARE';
export const ANNOTATION_LINE = 'LINE';
export const ANNOTATION_CIRCLE = 'CIRCLE';


// Sources
export const ANNOTATION_SOURCE_GLOBALREPO = 'GLOBALREPO';
